import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import styles from './BuilderCallHelperPopup.css';
import { CADASTRE_SERVICE_LINK } from '../../constants/base';
import { PhoneButtonSwitcher } from '../PhoneButtonSwitcher';
import { PopupModal } from '../PopupModal';

export interface IBuilderCallHelperPopupProps {
  phone?: string;
  workTime?: string | null;
  onClose(): void;
  onShowPhone(): void;
  onInit(): void;
  onCadastreLinkClick(url: string): void;
}

export class BuilderCallHelperPopup extends React.PureComponent<IBuilderCallHelperPopupProps> {
  public componentDidMount() {
    this.props.onInit();
  }

  public render() {
    const { phone, workTime, onClose, onShowPhone, onCadastreLinkClick } = this.props;

    if (!phone) {
      return null;
    }

    return (
      <PopupModal {...mergeStyles(styles['modal'], styles['modal--button'])} onClose={onClose}>
        <strong className={styles['title']}>О чём спросить у застройщика</strong>
        <div className={styles['content']}>
          <ul className={styles['list']}>
            <li className={styles['list-item']}>Если на участке есть дом, то он уже сдан или еще строится?</li>
            <li className={styles['list-item']}>
              Проведены ли газ, вода, электричество, канализация, интернет?
              Если&nbsp;нет,&nbsp;то&nbsp;есть&nbsp;ли&nbsp;они&nbsp;в&nbsp;планах? Попросите подтверждающие документы.
            </li>
            <li className={styles['list-item']}>Есть ли действующие акции и скидки?</li>
            <li className={styles['list-item']}>
              Какие у застройщика имеются документы права собственности на дом или землю?
            </li>
            <li className={styles['list-item']}>
              Кадастровый номер и адрес объекта. Проверить их можно&nbsp;
              <a
                className={styles['link']}
                href={CADASTRE_SERVICE_LINK}
                target="_blank"
                rel="nofollow noopener"
                onClick={() => onCadastreLinkClick(CADASTRE_SERVICE_LINK)}
              >
                здесь
              </a>
            </li>
          </ul>
          <a
            href="https://www.cian.ru/stati-chek-list-dlja-vybora-kottedzhnogo-poselka-316259/"
            target="_blank"
            className={styles['link']}
          >
            Чек-лист для выбора коттеджного поселка
          </a>
          <PhoneButtonSwitcher phone={phone} trackShowPhoneClick={onShowPhone} buttonSize="XS" />
          {workTime && <p className={styles['work_time']}>{workTime}</p>}
        </div>
      </PopupModal>
    );
  }
}
